import PackagePaymentModal from './PackagePaymentModal';

export default PackagePaymentModal;
